/* PreviewBannerComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PreviewBannerRenderer");

/**
 * @class PreviewBannerComponent
 * @extends EventEmitter
 *
 * @fires PreviewBannerComponent#Data
 * @fires PreviewBannerComponent#Error
 * @fires PreviewBannerComponent#Shutdown
 */

class PreviewBannerComponent extends EventEmitter {
    constructor(data) {
        super();
        this._model = data;
        this._registerListeners();
        this._renderer = new Renderer(this, data);
    }

    get renderer() {
        return this.getRenderer();
    }

    get rootElement() {
        return this._renderer.getRootElement();
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _triggerData(data) {
        /**
         * @event PreviewBannerComponent#Data
         * @param {Object} - entity properties.
         */
        this.emit("Data", data);
    }

    _triggerError(error) {
        /**
         * @event PreviewBannerComponent#Error
         * @param {*} - entity properties.
         */
        this.emit("Error", error);
    }

    _registerListeners() {}

    _unregisterListeners() {}

    _shutdown() {
        this.emit("Shutdown");
        this._unregisterListeners();

        return Promise.all([this._renderer.shutdown()])
            .then(() => {
                this._renderer = null;
                this._shutdownProm = null;
                this.removeAllListeners();
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    closePopUp(userRejected) {
        if(userRejected) {
            this.rejectPopUp({ userRejected: true });
        } else {
            this.resolvePopup();
        }
        
    }

    resolvePopup(data) {
        this._context.resolve(data);
    }

    rejectPopUp(data) {
        this._context.reject(data);
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = PreviewBannerComponent;
